module.exports = __webpack_public_path__ + "static/media/hotel.5d78ea8c.svg";